export function PrivacyPolicy() {
    return <div className='privacy-policy'>
        <h1>מדיניות פרטיות - Saltiz Picker</h1>

        <p>ברוכים הבאים ל־<strong>Saltiz Picker</strong>, אתר הדשבורד של חברת <strong>Saltiz LTD</strong>.</p>

        <h2>1. מידע שאנחנו אוספים</h2>
        <p>כאשר אתם נכנסים לאתר ומתחברים באמצעות כתובת אימייל או Google OAuth, אנו שומרים את כתובת האימייל שלכם במאגר הנתונים שלנו.</p>

        <h2>2. שימוש ב־Google OAuth</h2>
        <p>לצורך התחברות לאתר וגישה ללוח השנה שלכם, אנו עושים שימוש בשירות ההזדהות של Google (Google OAuth). בעת הענקת הרשאות, נאפשר צפייה וניהול של פרטי לוח השנה שלכם על פי הצורך של השירות.</p>

        <h2>3. איך אנו משתמשים במידע</h2>
        <ul>
            <li>כתובת האימייל משמשת לצורכי התחברות וזיהוי המשתמש בלבד.</li>
            <li>גישה ללוח השנה נועדה לספק את השירותים שהפלטפורמה מציעה (כגון תיאום פגישות או הצגת אירועים).</li>
        </ul>

        <h2>4. שמירה על פרטיות ואבטחת מידע</h2>
        <p>איננו משתפים את כתובת האימייל או כל מידע אישי אחר עם צדדים שלישיים.</p>
        <p>המידע נשמר בשרתים מאובטחים ומוגן באמצעים טכנולוגיים סבירים כנגד גישה לא מורשית.</p>

        <h2>5. עוגיות (Cookies)</h2>
        <p>האתר עשוי להשתמש בעוגיות כדי לשפר את חוויית המשתמש, לניהול סשן התחברות ולתמיכה טכנית.</p>

        <h2>6. שינויי מדיניות</h2>
        <p>אנו שומרים לעצמנו את הזכות לעדכן את מדיניות הפרטיות בכל עת. עדכונים מהותיים יוצגו באתר.</p>

        <h2>7. יצירת קשר</h2>
        <p>לשאלות בנוגע למדיניות הפרטיות, ניתן לפנות אלינו בדוא"ל: <a href="mailto:contact@thesaltiz.com">contact@thesaltiz.com</a></p>

        <p>עודכן לאחרונה: יוני 2025</p>
    </div>
}

